export default __webpack_public_path__ + "static/media/championspirit.13c1b2df.png";